export class TipiSezioneConfiguration {  
  public static ID_SEZIONE_CONTROPARTI: string = '2';
  public static ID_SEZIONE_LEGALI: string = '3';
  public static ID_SEZIONE_ALTREPARTI: string = '4';
  public static ID_SEZIONE_ECONOMICA: string = '5';
  public static ID_SEZIONE_SCADENZARIO: string = '6';
  public static ID_SEZIONE_ATTI: string = '7';
  public static ID_SEZIONE_INCASSI: string = '9';    
  public static ID_SEZIONE_PAGAMENTI: string = '10';
  public static ID_SEZIONE_PARCELLE: string = '11';
  public static ID_SEZIONE_ESITI: string = '12';
  public static ID_SEZIONE_TITOLI_ESECUTIVI: string = '13';
  public static ID_SEZIONE_DOCUMENTAZIONE: string = '14'; 
  public static ID_SEZIONE_FATTURE: string = '17';
  public static ID_SEZIONE_BENI_MOBILI: string = '18';
  public static ID_SEZIONE_PROVE_SCRITTE: string = '19';

  public static idTipoSezioneAdempimenti: string = '841e43d5-53ea-11ea-a08d-005056a8dd09';
  public static idTipoSezioneDocumentazioneFascicolo: string = '83c6536c-53ea-11ea-a08d-005056a8dd09';

}